<template>
<div class="page-wrapper content-wrappe">
  <div v-if="loading">
    <b-loading :is-full-page="false" :active="loading" />
  </div>

  <div class="panel" v-else-if="!loading">
    
  <div style="width: 100%;">
    <div class="content-title-wrapper">
      <label class="hierarchy-label">{{ worklistName }} > Case: {{ caseName }}</label>
      <div>
        <button
        v-for="tab in filteredTabList"
        :key="tab"
        @click="changeTab(tab)"
        :class="['tab-button', { active: tabCurrent === tab}]"
        > {{ capitalizeFirstLetter(tab) }} </button>
      </div>
    </div>
    <hr class="hr-style" />

    <!-- <div style="overflow: auto; height: 80vh;"> -->
    <div class="content-body-wrapper">
      <div v-if="tabCurrent == 'images'" >
        <ProjectImageListComponent style="overflow: auto;" :caseId="$route.params.idCase" />
      </div>
      <div v-else-if="tabCurrent == 'information'" >
        <ProjectInformationComponent />
      </div>
      <div v-else-if="tabCurrent == 'report'" >
        <ProjectReportComponent
         :caseId="project.id"
         :canEdit="canManageProject" />
      </div>
      <div v-else-if="tabCurrent == 'configuration'" >
        <ProjectConfigurationComponent />
      </div>
    </div>
  </div>

  </div>
</div>
</template>

<script>
import { ProjectCollection } from 'cytomine-client';
import ProjectImageListComponent from './ProjectImageListComponent.vue';
import ProjectInformationComponent from './ProjectInformationComponent.vue';
import ProjectReportComponent from './ProjectReportComponent.vue';
import ProjectConfigurationComponent from './ProjectConfigurationComponent.vue';
import DefaultWorklist from '../../enums/DefaultWorklist';
import { get } from '@/utils/store-helpers';
import { capitalizeFirstLetter } from '@/utils/string-utils.js';
import projectModuleModel from '@/store/modules/project';


export default {
  name: 'project-page',
  components : {
    ProjectImageListComponent,
    ProjectInformationComponent,
    ProjectReportComponent,
    ProjectConfigurationComponent,
  },
  data() {
    return {
      tabIndex: 1,
      tabList: ['images', 'information', 'report', 'configuration'],

      loading: true, // TODO: ture로 변경

      worklistName: null,
      caseName: null,
      
    };
  },
  // watch: {
  //   currentWorklist: {
  //     immediate: true,
  //     handler(newVal) {
  //       if (newVal) {
  //         console.log('current worklist changed', newVal);
  //         // this.loading = false;
  //         // this.fetchProjects(newVal.id);
  //       }
  //       else {
  //         console.log('no current worklist');
  //       }
  //     }
  //   },
  // },
  watch: {
    async idProject() {
      this.loading = true;
      await this.loadProject();
    },

  },
  computed: {
    currentUser: get('currentUser/user'),
    project: get('currentProject/project'),
    configUI: get('currentProject/configUI'),
    idProject() {
      console.log('!!!!!!!!!!!!!!! CytomineProject idCase', this.$route.params.idCase);
      return this.$route.params.idCase;
    },
    // projectModule() {
    //   return this.$store.state.projects[this.idProject];
    // },
    tabCurrent() {
      return this.$route.query.tab;
    },
    filteredTabList() {
      return this.tabList.filter(tab => {
        if (tab === 'configuration') {
          return this.configUI && this.configUI['project-configuration-tab'];
        }
        return true;
      });
    },
    // currentWorklist() {
    //   return this.$store.getters['worklist/getCurrentWorklist'];
    // },
    canManageProject() {
      return this.$store.getters['currentProject/canManageProject'];
    },
    canAddImage() {
      return !this.currentUser.guestByNow && (this.canManageProject || !this.project.isReadOnly);
    },
  },
  methods: {
    capitalizeFirstLetter,
    async loadProject() {
      try {
        if (!this.$store.state.projects[this.idProject]) { // module does not exist yet
          this.$store.registerModule(['projects', this.idProject], projectModuleModel);
        }
        await this.$store.dispatch('currentProject/loadProject', this.idProject);
        this.loading = false;
      }
      catch (error) {
        console.log(error);
        if (error.response && error.response.status === 403) {
          this.permissionError = true;
        }
        else {
          this.notFoundError = true;
        }
      }
    },
    changeTab(tabName) {
      const { tab } = this.$route.query;
      const idCase = this.$route.params.idCase;

      // 현재 위치와 비교
      const isSameTab = tab === tabName;
      const isSamePath = this.$route.path === `/worklist/${this.$route.params.sortPropWorklist}-${this.$route.params.idWorklist}/case/${idCase}`;

      if (isSameTab && isSamePath) {
        return;
      }
      this.$router.push({ path: `/worklist/${this.$route.params.sortPropWorklist}-${this.$route.params.idWorklist}/case/${idCase}`, query: {  tab: tabName } });
    },
  },
  async created() {
    // project 기본 정보를 가져오기 - 속한 worklist의 이름, project의 이름
    if (this.$route.params.sortPropWorklist == 'status') {
      let defaultInfo = await ProjectCollection.fetchDefaultInfo(null, this.$route.params.idCase);
      this.worklistName = DefaultWorklist[this.$route.params.idWorklist];
      this.caseName = defaultInfo.caseName;
    }
    else {
      let defaultInfo = await ProjectCollection.fetchDefaultInfo(this.$route.params.idWorklist, this.$route.params.idCase);
      this.worklistName = defaultInfo.worklistName;
      this.caseName = defaultInfo.caseName;
    }

    await this.loadProject(); // CHECK: 위 내용이랑 중복인가?
    this.loading = false;
  },
};

</script>

<style scoped>

.page-wrapper {
  vertical-align: middle !important;
  /* display: flex; */
  height: 100%;
  /* overflow: auto; */
}
.content-wrappe {
  padding: 0 2.5%;
  position: relative;
  min-height: 100%;

  overflow: hidden;
}

.content-title-wrapper {
  height: 75px;
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
}
.hierarchy-label {
  margin: 18px 10px;
  font-size: 1.3rem;
  color: #4A4847;
}
.tab-button {
  all: unset;
  padding: 0.5rem 1rem;
  font-size: 1.2rem;
}

.content-body-wrapper {
  height: calc(100vh - 75px);
  /* height: calc(100vh - var(--navbar-height) - 75px - 40px - 50px); */
  overflow: auto;
}

.hr-style {
  margin: 0;
}

.panel {
  display: flex;
  flex-direction: row;
}

button.active {
  color: #009BDB;
  border-bottom: 3px solid #009BDB;
}

</style>
